import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ConfigurationComponent} from "./configuration.component";

const routes: Routes = [
  { path: '', component: ConfigurationComponent},
  { path: 'configuration/brand/:brandId', loadChildren: () => import('./brand/brand.module').then(m => m.BrandModule) },
  { path: 'configuration/brand/:brandId/product/:productUid', loadChildren: () => import('./product/product.module').then(m => m.ProductModule) },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigurationRoutingModule {
  static components = [ ConfigurationComponent];
}
